import React from 'react';

// alternative list plugins: slate-edit-list, @guestbell/slate-edit-list

// @convertkit/slate-lists plugin adds commands:
// wrapList, unwrapList, toggleList({ type: 'ordered_list' }), unwrapListByKey, decreaseListItemDepth, increaseListItemDepth
import listPlugin from '@convertkit/slate-lists';

export {
  MdFormatListBulleted as ListIcon,
  MdFormatIndentIncrease as ListDepthIncreaseIcon,
  MdFormatIndentDecrease as ListDepthDecreaseIcon,
} from 'react-icons/md';

const LIST_ITEM = 'list-item';
const LIST_ITEM_CHILD = 'list-item-child';
const UNORDERED_LIST = 'unordered-list';


const plugin = () => {
  const [core, keymap] = listPlugin();

  return {
    core: {
      ...core,
      serialize: (node, children) => {
        if (node.type === LIST_ITEM) {
          return node.object === 'block' ? <li style={{ listStyleType: 'disc' }}>{children}</li> : <li>{node.text}</li>;
        }
        if (node.type === LIST_ITEM_CHILD) {
          return node.object === 'block' ? <span>{children}</span> : <span>{node.text}</span>;
        }
        if (node.type === UNORDERED_LIST) {
          return <ul>{children}</ul>;
        }
      },
    },
    keymap,
  };
};

export default plugin;
